module.exports = __webpack_public_path__ + "img/nav-right-with-contact-toolbar-infiniti.5d4307a6.png";